import { useMemo, useEffect, useState } from 'react';
import { FormLabel, Grid, Chip, Avatar, Tooltip } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../ReportsScreens/GijgoForReportsScreen';
import { DatePicker, MultipleSelectWithMoreOp, SingelSelect, SelectBox } from '../../../../Core/FormInput';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { GetTCardDashDropdowns, getTCardSchedules, getTCardSchedulesExcelFile } from '../../../../Core/Service/T-card-services';
import formatters from '../../../../Core/Grid/inputFormatter';
import ReactDOM from 'react-dom';
import LinkIcon from '@material-ui/icons/Link';
import TCardModal from '../../../CheckIn/Dashboard/TcardModal';
import DialogComp from '../../../../Core/Modal/dialogModal';
import TCardDashboardModal from '../Dashboard/T-cardModal';

const baseColumns = [
    { field: 'regNo', sortable: true, title: `Reg No`, width: 40 },
    { field: 'dueDate', sortable: true, title: `Due Date`, width: 50, renderer: formatters.YearFormatter },
    { field: 'event', sortable: true, title: 'Event', width: 80 },
    { field: 'scheduleType', sortable: true, title: `Schedule Type`, width: 60 },
    { field: 'customer', sortable: true, title: `Customer`, width: 90 },
    { field: 'branch', sortable: true, title: `Branch`, width: 50 },
    { field: 'lastDone', sortable: true, title: `Last Done`, width: 50, renderer: formatters.YearFormatter },
    { field: 'lastDoneKM', sortable: true, title: `Last Done KM`, width: 70 },
    { field: 'cashAccount', sortable: true, title: `Cash Account`, width: 70, renderer: formatters.YesNoFormatter }

    // { field: '', sortable: true, title: 'Last Done / KM', width: 120,
    //     renderer: function (value, record) {
    //     const formattedDate = formatters.DateTimeFormatter(record.lastDone);
    //     return `${formattedDate} ${record.lastDoneKM}`; }
];

const crumbs = () => {
    let list = [
        { name: 'Home', path: '/' },
        { name: 'T-card', active: true },
        { name: 'Vehicle Schedules', active: true }
    ];
    return list;
};

const useStyles = makeStyles((theme) => ({
    columnStyle: {
        cursor: 'pointer'
    }
}));

const TCardSchedules = (props) => {
    let currentISOWeek = moment().isoWeek();
    let startWeek = currentISOWeek + 1;
    let endWeek = currentISOWeek + 1;
    let startDate = moment().isoWeek(startWeek).startOf('isoWeek').format('YYYY-MM-DD');
    let endDate = moment().isoWeek(endWeek).endOf('isoWeek').format('YYYY-MM-DD');

    const [state, setState] = useState({
        startDate: startDate,
        endDate: endDate,
        branchList: [],
        branchID: null,
        isReload: '',
        showTCardModal: false,
        selectedVehicle: {},
        scheduleList: [],
        rows: []
    });
    const [isShow, setIsShow] = useState(true);

    const [temp, tempOption] = useState({
        groupVal: []
    });

    let DummyList = [];

    // useEffect(async () => {
    //     let res = await GetTCardDashDropdowns();

    //     if (res.success) {
    //         setState((st) => ({
    //             ...st,
    //             branchList: res.data?.branches || [],
    //             branchID: res.data?.branches[0]?.id
    //         }));
    //     }
    // }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let res = await GetTCardDashDropdowns();
                if (res?.success && Array.isArray(res.data?.branches)) {
                    const branches = res.data.branches;

                    const dashboardData = JSON.parse(localStorage.getItem('_dashboard_') || '{}');
                    const selectedBranchName = dashboardData.BranchPartReq;

                    const matchedBranch = branches.find((b) => b.name === selectedBranchName);
                    const fallbackBranchID = branches[0]?.id || null;

                    setState((st) => ({
                        ...st,
                        branchList: res.data?.branches || [],
                        branchID: matchedBranch?.id || fallbackBranchID
                    }));
                } else {
                    console.error('Failed to fetch branches or no branches returned');
                }
            } catch (error) {
                console.error('Error fetching TCard branch data:', error);
            }
        };

        fetchData();
    }, []);

    const onRowDataBound = (e, $row, id, record, GridRef) => {
        if (record.tCardID) {
            var checkboxCell = $row.find('input[type="checkbox"][data-role="selectRow"]').closest('td');
            checkboxCell.empty().append('<span></span>');
        }
    };
    const onRowSelect = (e, $row, id, record, GridRef) => {
        if (DummyList.length > 0) {
            let isChecked = DummyList.some((q) => q.regNo === record.regNo);
            if (isChecked) {
                DummyList.push(record);
            } else {
                GridRef.setSelected(id);
                alert('Please select same reg no');
                e.preventDefault(); // Prevent the default behavior of the checkbox
                return;
            }
        } else {
            DummyList.push(record);
        }
    };

    const onRowUnSelect = (e, $row, id, record) => {
        let vehicleIndex = DummyList.findIndex((q) => q.regNo === record.regNo);
        if (vehicleIndex > -1) {
            DummyList.splice(vehicleIndex, 1);
        }
    };
    const getVal = () => {
        setState((st) => ({
            ...st,
            showTCardModal: true,
            scheduleList: DummyList
        }));
    };
    const getRes = async () => {
        let res = await getTCardSchedules(state.branchID, state.startDate, state.endDate);
        setState((st) => ({
            ...st,
            rows: res.data?.tCards
        }));
    };
    const getExcel = async () => {
        let res = await getTCardSchedulesExcelFile(state.branchID, state.startDate, state.endDate);
    };
    const closeWarningModal = (isUpdateFlag) => {
        setState((st) => {
            let newSt = { ...st };
            newSt.showTCardModal = false;
            newSt.showUpdateTCard = false;
            newSt.tCardsID = null;

            if (isUpdateFlag) newSt.isReload = new Date();
            return newSt;
        });
        isUpdateFlag && getRes();
    };

    const mailButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justify="center">
                <Tooltip title={'T - card'}>
                    <Chip
                        avatar={
                            <Avatar style={{ marginRight: '-20px' }}>
                                <LinkIcon />
                            </Avatar>
                        }
                        onClick={getVal}
                    />
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleinput = (e) => {
        const branchID = e.target.value;
        const tempObj = state.branchList.find((k) => k.id == branchID);

        if (tempObj) {
            const branchName = tempObj.name;

            const tempData = {
                ...JSON.parse(localStorage.getItem('_dashboard_') || '{}'),
                BranchBytime: branchName,
                selectedValueByTech: branchName,
                BranchPartReq: branchName,
                branchShortName: branchName
            };
            localStorage.setItem('_dashboard_', JSON.stringify(tempData));

            const btTimeData = {
                ...JSON.parse(localStorage.getItem('FiltterParams') || '{}'),
                branchShortName: branchName
            };
            localStorage.setItem('FiltterParams', JSON.stringify(btTimeData));
        }

        setState((st) => ({
            ...st,
            [e.target.name]: branchID,
            isReload: new Date()
        }));
    };
    useEffect(() => {
        if (state.branchID) {
            getRes();
        }
    }, [state.branchID, state.startDate, state.endDate]);

    const handleReg = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justify="center">
                {record.tCardID ? (
                    <span
                        style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={() => {
                            setState((st) => ({
                                ...st,
                                tCardsID: record.tCardID,
                                showUpdateTCard: true
                            }));
                        }}
                    >
                        {value}
                    </span>
                ) : (
                    value
                )}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    let Column = useMemo(() => {
        let TempCol = [...baseColumns];
        let colReg = TempCol.find((q) => q.field === 'regNo');
        if (colReg) {
            colReg.renderer = handleReg;
        }

        return TempCol;
    }, []);

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs()} />
            <Grid container spacing={1} style={{ padding: '10px 0px' }}>
                <Grid item xs={4} md={3} lg={2}>
                    <FormLabel component="legend" className="mandatoryfields" style={{ marginBottom: 10 }}>
                        Start Date
                    </FormLabel>
                    <DatePicker placeholder="Start Date" name="startDate" fullWidth value={state.startDate} onChange={handleinput} />
                </Grid>
                <Grid item xs={4} md={3} lg={2}>
                    <FormLabel component="legend" className="mandatoryfields" style={{ marginBottom: 10 }}>
                        End Date
                    </FormLabel>
                    <DatePicker placeholder="End Date" name="endDate" fullWidth value={state.endDate} onChange={handleinput} />
                </Grid>
                <Grid item xs={4} md={3} lg={2}>
                    <FormLabel component="legend" className="mandatoryfields" style={{ marginBottom: 10 }}>
                        Branch
                    </FormLabel>
                    <SelectBox List={state.branchList || []} insertEmpty={false} onChange={handleinput} value={state.branchID} name="branchID" />
                </Grid>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        columns={Column}
                        displayPagination={true}
                        localRowsData={state.rows}
                        isReload={state.isReload}
                        onRowDataBound={(e, $row, id, record, GridRef) => onRowDataBound(e, $row, id, record, GridRef)}
                        showCheckboxColFilterBtn={mailButton}
                        selectionType={'multiple'}
                        selectionMethod={'checkbox'}
                        hideHeaderCheckbox={true}
                        onRowSelect={(e, $row, id, record, GridRef) => onRowSelect(e, $row, id, record, GridRef)}
                        onRowUnSelect={(e, $row, id, record, GridRef) => onRowUnSelect(e, $row, id, record, GridRef)}
                        downloadName={'Vehicle Schedules'}
                        downloadBtnName={getExcel}
                        uniqueGridName="t_cardVrhivleSchedules"
                    />
                </Grid>
            </Grid>
            {state.showTCardModal && (
                <DialogComp title={'Create T-Card'} maxWidth="xl" onClose={() => closeWarningModal(false)} overflow="auto">
                    <TCardModal onClose={closeWarningModal} scheduleList={state.scheduleList} hideIsNightShiftFlag={true} />
                </DialogComp>
            )}
            {state.showUpdateTCard && (
                // <DialogComp title={'opopop'} maxWidth="xl" onClose={handleClose} fullWidth overflow="auto" fullScreen>
                <TCardDashboardModal id={state.tCardsID} onClose={closeWarningModal} />
                // </DialogComp>
            )}
        </div>
    );
};
export default TCardSchedules;
